/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CardContent, Checkbox, Collapse, Dialog, FormControl, FormControlLabel, IconButton, Stack, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { ExpandMore } from '@mui/icons-material';
import { Button } from 'react-bootstrap';
import { getDatabaseTags, getDatabaseQuestionByID, getDatabaseQuestionLanguages, getCodingQuestionReturnTypes, getQuestionLevels, createDatabaseTest, updateDatabaseTest } from '../../Redux/ActionCreators/testLibraryAction';
import JoditEditor from 'jodit-react';
import { returnErrors } from '../../Redux/ActionCreators/errorAction';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const CreateDatabaseQuestions = (props) => {
  const details = JSON.parse(localStorage.getItem("profileDetails"));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const descriptionEditorRef = useRef(null);

  const {
    questionLevel,
    dbTags,
    databaseQuestionLanguagesOptions,
    databaseQuestionByIdResponse,
    loadingDatabaseQuestionById,
  } = useSelector((state) => state.testLibrary);

  const [questionTitle, setQuestionTitle] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [configuration, setConfiguration] = useState("");
  const [solution, setSolution] = useState("");
  const [tags, setTags] = useState([]);
  const [programmingLanguages, setProgrammingLanguages] = useState([]);
  const [questionWeightage, setQuestionWeightage] = useState(10);
  const [timeDuration, setTimeDuration] = useState(15);
  const [selectDifficulty, setSelectDifficulty] = useState(1);
  const [expanded, setExpanded] = useState(true);

  const [testCases, setTestCases] = useState([
    { sqlQuery: "", isSample: true, weightage: 5 },
  ]);

  useEffect(() => {
    const fetchAll = async () => {
        setLoading(true);
        try {
            if (location?.state?.detail?.id) {
                await dispatch(getDatabaseQuestionByID(location?.state?.detail?.id));
            }
            await Promise.all([
                dispatch(getDatabaseQuestionLanguages()),
                dispatch(getCodingQuestionReturnTypes()),
                dispatch(getQuestionLevels())
            ]);
        } catch (error) {
            console.error("Error fetching question setup data:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchAll();
}, []);

    useEffect(() => {
      if (databaseQuestionByIdResponse) {
        const { question } = databaseQuestionByIdResponse;
        setQuestionTitle(question?.name);
        setQuestionDescription(question?.description);
        setConfiguration(question?.data?.configuration || "");
        setSolution(question?.data?.solution || "");
        setQuestionWeightage(question?.weightage);
        setTimeDuration(question?.duration);
        setSelectDifficulty(question?.difficultyLevelId);
        setProgrammingLanguages(
          question?.languages?.map((el) => ({
            label: el.displayLanguage,
            value: el.databaseLanguageId,
          }))
        );
        setTags(question?.tags?.map((el) => ({ label: el, value: el })));
        setTestCases(question?.data?.testCases || []);
      }
    }, [databaseQuestionByIdResponse]);

  const handleExpandClick = () => setExpanded((prev) => !prev);

  const selectLanguage = async (e) => {
    if (e.some((el) => el.value === "all")) {
      await setProgrammingLanguages(
        databaseQuestionLanguagesOptions?.map((el) => ({
          label: el.displayLanguage,
          value: el.id,
        }))
      );
    } else {
      await setProgrammingLanguages(e);
    }
  };

  const handleTags = (e) => setTags(e);

  const validateForm = () => {
    if (!questionTitle) return returnErrors(dispatch, "Question name required", 500);
    if (!questionDescription)
      return returnErrors(dispatch, "Description required", 500);
    if (!configuration)
      return returnErrors(dispatch, "Configuration required", 500);
    if (!solution) return returnErrors(dispatch, "Solution required", 500);
    if (!programmingLanguages.length)
      return returnErrors(dispatch, "Select at least one language", 500);
    if (!tags.length) return returnErrors(dispatch, "Add at least one tag", 500);
    if (!testCases.length)
      return returnErrors(dispatch, "Add at least one test case", 500);

    return true;
  };

  const handleTestCaseChange = (index, field, value) => {
    const updated = [...testCases];
    updated[index][field] = value;
    setTestCases(updated);
  };

  const removeTestCase = (index) => {
    const updated = [...testCases];
    updated.splice(index, 1);
    setTestCases(updated);
  };

  const questionSaveHandler = async () => {
    setLoading(true);
    if (!validateForm()) return setLoading(false);

    const payload = {
      name: questionTitle,
      description: questionDescription,
      duration: Number(timeDuration),
      difficultyLevelId: Number(selectDifficulty),
      weightage: Number(questionWeightage),
      tenantId: parseInt(details?.tenentId),
      languages: programmingLanguages.map((el) => ({
        databaseLanguageId: el.value,
      })),
      tags: tags.map((el) => el.value),
      data: {
        configuration,
        solution,
        testCases: testCases.map((t) => ({
          sqlQuery: t.sqlQuery,
          isSample: t.isSample,
          weightage: Number(t.weightage),
        })),
      },
    };

    if (location?.state?.edit) {
      const response = await dispatch(updateDatabaseTest({ ...payload, id: location?.state?.detail?.id }));
      if (response?.type === "UPDATE_DATABASE_TEST") navigate(-1);
    } else {
      const response = await dispatch(createDatabaseTest(payload));
      if (response?.type === "CREATE_DATABASE_TEST")
        props.addFromList ? props.goBack() : navigate(-1);
    }

    setLoading(false);
  };

  return (
    <div className="bg-white rounded mt-3 mb-3 px-5 py-3 create-question-main">
      <div className="d-flex align-items-center">
        <img
          src="/images/back.svg"
          alt=""
          className="cursor-pointer"
          onClick={props.onClose}
        />
        &nbsp;&nbsp;
        <h1 className="maintxt">
          {location?.state?.view
            ? "View Database Question"
            : location?.state?.edit
            ? "Edit Database Question"
            : "Create Database Question"}
        </h1>
      </div>

      <Stack spacing={4} mt={4}>
        <div className="form-group">
          <label>Question Name*</label>
          <input
            type="text"
            className="form-control"
            value={questionTitle}
            onChange={(e) => setQuestionTitle(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Question Description*</label>
          <JoditEditor
            ref={descriptionEditorRef}
            value={questionDescription}
            onChange={(content) => setQuestionDescription(content)}
          />
        </div>

        <div className="form-group">
          <label>Configuration*</label>
          <textarea
            className="form-control"
            rows="4"
            value={configuration}
            onChange={(e) => setConfiguration(e.target.value)}
          ></textarea>
        </div>

        <div className="form-group">
          <label>Solution*</label>
          <textarea
            className="form-control"
            rows="4"
            value={solution}
            onChange={(e) => setSolution(e.target.value)}
          ></textarea>
        </div>

        <Stack spacing={2}>
          <label>Programming Languages*</label>
          <Select
            isMulti
            options={[
              { label: "Select all", value: "all" },
              ...databaseQuestionLanguagesOptions?.map((el) => ({
                label: el.displayLanguage,
                value: el.id,
              })),
            ]}
            value={programmingLanguages}
            onChange={selectLanguage}
          />
        </Stack>

        <Stack spacing={2}>
          <label>Tags*</label>
          <CreatableSelect
            options={dbTags}
            isMulti
            value={tags}
            onChange={handleTags}
          />
        </Stack>

        <Stack direction="row" spacing={2}>
          <div>
            <label>Time* (Minutes)</label>
            <input
              type="number"
              className="form-control"
              value={timeDuration}
              onChange={(e) => setTimeDuration(e.target.value)}
            />
          </div>
          <div>
            <label>Score* (Marks)</label>
            <input
              type="number"
              className="form-control"
              value={questionWeightage}
              onChange={(e) => setQuestionWeightage(e.target.value)}
            />
          </div>
          <div>
            <label>Difficulty* (Level)</label>
            <select
              className="form-control"
              value={selectDifficulty}
              onChange={(e) => setSelectDifficulty(e.target.value)}
            >
              {questionLevel?.map((opt) => (
                <option key={opt.questionLevelID} value={opt.questionLevelID}>
                  {opt.questionLevelName}
                </option>
              ))}
            </select>
          </div>
        </Stack>
      </Stack>

      <br />
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer',}} onClick={handleExpandClick}>
        <ExpandMore expand={expanded?.toString()} onClick={handleExpandClick} aria-expanded={expanded}aria-label="show test cases">
          <ExpandMoreIcon />
        </ExpandMore>
        <h3 className='text-start' style={{color:'black'}}>Test Cases*</h3>
      </Box>

      <Collapse in={expanded}>
        <CardContent>
          {testCases.map((t, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                p: 2,
                mb: 2,
              }}
            >
              <TextField
                fullWidth
                label="Sample Test Case"
                value={t.sqlQuery}
                onChange={(e) =>
                  handleTestCaseChange(index, "sqlQuery", e.target.value)
                }
                multiline
                rows={3}
              />

              <Stack direction="row" spacing={2} mt={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={t.isSample}
                      onChange={(e) =>
                        handleTestCaseChange(index, "isSample", e.target.checked)
                      }
                    />
                  }
                  label="Sample Test Case"
                />

                <TextField
                  label="Weightage"
                  type="number"
                  value={t.weightage}
                  onChange={(e) =>
                    handleTestCaseChange(index, "weightage", e.target.value)
                  }
                />
                {index > 0 && (
                  <IconButton onClick={() => removeTestCase(index)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Stack>
            </Box>
          ))}
          {expanded && <Button style={{ color: '#009199', fontWeight: 'bold' }} onClick={() => setTestCases([...testCases, { sqlQuery: "", isSample: false, weightage: 5 }])} variant="outlined">Add more test cases</Button>}
        </CardContent>
      </Collapse>

      <div style={{ textAlign: "end" }}>
        <button
          style={{
            backgroundColor: "var(--button-color)",
            color: "#fff",
            borderRadius: "12px",
            height: 48,
            border: "none",
            fontSize: 14,
            padding: "10px 30px",
            minWidth: 150,
            marginBottom: 50,
          }}
          disabled={loading}
          onClick={questionSaveHandler}
        >
          Save
        </button>
      </div>

      {loading && (
        <Dialog
          className="screen-loader"
          open={loading}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          Loading ...
        </Dialog>
      )}
    </div>
  );
};

export default CreateDatabaseQuestions;